import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  useTheme,
  IconButton,
} from "@mui/material";
import RulesForm from "./RulesForm";
import CloseIcon from "@mui/icons-material/Close";

const Blacklist = (props) => {
  const theme = useTheme();
  const {
    managers,
    strategies,
    openBlacklistPopup,
    setBlacklistOpenPopup,
    title,
  } = props;
  const [blacklistData, setBlacklistData] = useState({});

  function consolidateRules(data) {
    const consolidatedRules = [];
    const ruleMap = {};

    data?.rules?.forEach((rule) => {
      if (rule.ticker) {
        const { ticker, ...rest } = rule;
        const key = JSON.stringify(rest);

        if (!ruleMap[key]) {
          ruleMap[key] = {
            ...rest,
            tickers: [],
          };
          consolidatedRules.push(ruleMap[key]);
        }
        ruleMap[key].tickers.push(ticker.symbol);
      } else {
        consolidatedRules.push(rule);
      }
    });

    return {
      ...data,
      rules: consolidatedRules,
    };
  }

  useEffect(() => {
    if (managers && managers.length > 0 && managers[0].blacklist) {
      const mergedRules = consolidateRules(managers[0]?.blacklist);
      setBlacklistData(mergedRules);
    }
  }, [managers]);

  return (
    <>
      <Dialog
        fullWidth
        open={openBlacklistPopup}
        maxWidth="lg"
        sx={{
          "& .css-1t1j96h-MuiPaper-root-MuiDialog-paper": {
            minWidth: "1000px",
            height: "100vh",
          },
        }}
      >
        <DialogTitle>
          <Typography
            variant="h6"
            component="div"
            align="center"
            style={{ flexGrow: 1, fontSize: "20px" }}
          >
            {title}
          </Typography>
          <IconButton
            aria-label="close"
            onClick={() => setBlacklistOpenPopup(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{ height: "50vh", overflow: "auto", borderBottom: "0px" }}
          dividers
        >
          <RulesForm
            blacklistData={blacklistData}
            strategies={strategies}
            openBlacklistPopup={openBlacklistPopup}
            setBlacklistOpenPopup={setBlacklistOpenPopup}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Blacklist;